import { render, staticRenderFns } from "./SearchHighLightView.vue?vue&type=template&id=653ac954&scoped=true&"
import script from "./SearchHighLightView.vue?vue&type=script&lang=ts&"
export * from "./SearchHighLightView.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHighLightView.vue?vue&type=style&index=0&id=653ac954&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ac954",
  null
  
)

export default component.exports